module.exports = __webpack_public_path__ + "static/media/tools.b4faba6b.png";